export const pizzaPricesCombinadasVegetarianas = [
  {
    key: "Champiñónes + vegetal",
    value: {
      personal: 7000,
      pequeña: 12990,
      mediana: 21990,
      grande: 27990,
    },
    text: "Champiñónes + vegetal",
    description: "Deliciosa pizza de champiñónes más (un) vegetal",
    pizzaImg:require('../img/imgMenuPizzas/pizzaChampiñonesCebollaCaramelizada.png'),
  },
  {
    key: "Amigos especiales",
    value: {
      personal: 8500,
      pequeña: 15990,
      mediana: 25990,
      grande: 35990,
    },
    text: "Amigos especiales",
    description:
      "Tomate cherry, pimenton verde, cebolla roja, aceitunas verde, champiñones",
    pizzaImg: require("../img/imgMenuPizzas/pizzaAmigosEspeciales.jpg"),
  },
  {
    key: "Amigo secreto",
    value: {
      personal: 8500,
      pequeña: 15990,
      mediana: 25990,
      grande: 35990,
    },
    text: "Amigo secreto",
    description:
      "Tomate en trozos, champiñones, albahaca, queso holandes y parmesano.",
    pizzaImg: require("../img/imgMenuPizzas/pizzaAmigoSecreto.png"),
  },
  {
    key: "Amigos con derecho",
    value: {
      personal: 8500,
      pequeña: 15990,
      mediana: 25990,
      grande: 35990,
    },
    text: "Amigos con derechos",
    description:
      "Champiñones, tomate cherry, cebolla caramelizada, queso holandes y parmesano.",
    pizzaImg: require("../img/imgMenuPizzas/pizzaAmigosDerecho.jpeg"),
  },
];
